"use strict";
/**
 * Copyright © 2019 - Present, VamStar Limited
 * All rights reserved.
 *
 * Redistribution and use in source and binary forms, with or
 * without modification, are not permitted.
 */
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.InitStoriesTheme = void 0;
const React = __importStar(require("react"));
const material_1 = require("@mui/material");
const theme_options_1 = require("../constants/theme/theme-options");
/**
 * This is a utility wrapper to mock theme on each and every story (Not actually is a story)
 * @param props - props with children
 */
exports.InitStoriesTheme = (props) => {
    const { children } = props;
    return (React.createElement(React.Fragment, null,
        React.createElement(material_1.StyledEngineProvider, { injectFirst: true },
            React.createElement(material_1.ThemeProvider, { theme: theme_options_1.themeOptions },
                React.createElement(material_1.CssBaseline, null),
                children))));
};
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiaW5pdC1zdG9yaWVzLXRoZW1lLmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiLi4vLi4vLi4vc3JjL3V0aWxzL2luaXQtc3Rvcmllcy10aGVtZS50c3giXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IjtBQUFBOzs7Ozs7R0FNRzs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7OztBQUVILDZDQUErQjtBQUMvQiw0Q0FBaUY7QUFFakYsb0VBQWdFO0FBRWhFOzs7R0FHRztBQUNVLFFBQUEsZ0JBQWdCLEdBQUcsQ0FBQyxLQUFtQyxFQUFFLEVBQUU7SUFDdEUsTUFBTSxFQUFFLFFBQVEsRUFBRSxHQUFHLEtBQUssQ0FBQztJQUMzQixPQUFPLENBQ0w7UUFDRSxvQkFBQywrQkFBb0IsSUFBQyxXQUFXO1lBQy9CLG9CQUFDLHdCQUFhLElBQUMsS0FBSyxFQUFFLDRCQUFZO2dCQUNoQyxvQkFBQyxzQkFBVyxPQUFHO2dCQUNkLFFBQVEsQ0FDSyxDQUNLLENBQ3RCLENBQ0osQ0FBQztBQUNKLENBQUMsQ0FBQyJ9